import React, { useEffect, useRef, useState } from "react";

import EnvironmentProvider from "../../Analytics/EnvironmentContext";
import videoData from '../VideoSequence/data.json';

import "./index.scss";

function App() {
  const [shouldUpdate, setShouldUpdate] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    if (shouldUpdate) setShouldUpdate(false);
  }, [shouldUpdate]);

  return (
    <div id="edint-video-play-on-scroll-with-texts-overlay-video3__app" ref={containerRef}>
      <EnvironmentProvider
        initialProps={{
          type: `${videoData.analyticsKey}-interactive|viewport`,
          rootEl: containerRef.current,
        }}
        data={{
           type: `${videoData.analyticsKey}-interactive|viewport`,
        }}
      ></EnvironmentProvider>
    </div>
  )
}

export default App;
